import { render, staticRenderFns } from "./VircosDelivery.vue?vue&type=template&id=72d5f558&scoped=true&"
import script from "./VircosDelivery.vue?vue&type=script&lang=js&"
export * from "./VircosDelivery.vue?vue&type=script&lang=js&"
import style0 from "./VircosDelivery.vue?vue&type=style&index=0&id=72d5f558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d5f558",
  null
  
)

export default component.exports